import { useState, useRef, useEffect } from "react";
import { createComponent } from "../utils";

export default createComponent({
  name: "Number",
  group: "Input",
  icon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8.39 12.648a1.32 1.32 0 0 0-.015.18c0 .305.21.508.5.508.266 0 .492-.172.555-.477l.554-2.703h1.204c.421 0 .617-.234.617-.547 0-.312-.188-.53-.617-.53h-.985l.516-2.524h1.265c.43 0 .618-.227.618-.547 0-.313-.188-.524-.618-.524h-1.046l.476-2.304a1.06 1.06 0 0 0 .016-.164.51.51 0 0 0-.516-.516.54.54 0 0 0-.539.43l-.523 2.554H7.617l.477-2.304c.008-.04.015-.118.015-.164a.512.512 0 0 0-.523-.516.539.539 0 0 0-.531.43L6.53 5.484H5.414c-.43 0-.617.22-.617.532 0 .312.187.539.617.539h.906l-.515 2.523H4.609c-.421 0-.609.219-.609.531 0 .313.188.547.61.547h.976l-.516 2.492c-.008.04-.015.125-.015.18 0 .305.21.508.5.508.265 0 .492-.172.554-.477l.555-2.703h2.242l-.515 2.492zm-1-6.109h2.266l-.515 2.563H6.859l.532-2.563z" />
    </svg>
  ),
  inputs: [],
  controls: [
    {
      id: "number",
      name: "Number",
      type: "Number",
      Render: (props) => {
        const [inputOptions, setInputOptions] = useState({
          min: 0,
          max: 10,
          step: 1,
          type: "range",
        });

        const [open, setOpen] = useState(false);

        const dialogRef = useRef(null);

        useEffect(() => {
          const dialogNode = dialogRef.current;

          dialogNode.addEventListener("cancel", () => {
            setOpen(false);
          });

          if (open) {
            dialogNode.showModal();
          } else {
            dialogNode.close();
          }
        }, [open]);

        function onCloseClick(e) {
          if (e.target.tagName === "DIALOG") {
            setOpen(false);
          }
        }

        return (
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
            }}
          >
            <div onClick={onCloseClick} style={{ padding: 0 }}>
              <dialog onKeyDown={(e) => e.stopPropagation()} ref={dialogRef}>
                <label>Min</label>
                <input
                  value={inputOptions.min}
                  onChange={(e) =>
                    setInputOptions({ ...inputOptions, min: e.target.value })
                  }
                  type="number"
                ></input>
                <label>Max</label>
                <input
                  value={inputOptions.max}
                  onChange={(e) =>
                    setInputOptions({ ...inputOptions, max: e.target.value })
                  }
                  type="number"
                ></input>
                <label>
                  Number
                  <input
                    type="radio"
                    name="type"
                    value="number"
                    checked={inputOptions.type === "number"}
                    onChange={(e) =>
                      setInputOptions({ ...inputOptions, type: e.target.value })
                    }
                  ></input>
                </label>
                <label>
                  Range
                  <input
                    type="radio"
                    name="type"
                    checked={inputOptions.type === "range"}
                    value="range"
                    onChange={(e) =>
                      setInputOptions({ ...inputOptions, type: e.target.value })
                    }
                  ></input>
                </label>
              </dialog>
            </div>

            {inputOptions.type === "range" && (
              <small style={{ minWidth: "40px" }}>{props.value || 0}</small>
            )}
            <input
              onDoubleClick={() => setOpen(true)}
              value={props.value || 0}
              onChange={(e) => {
                props.onChange(parseInt(e.target.value));
              }}
              style={{ width: "70px", height: "30px", textAlign: "center" }}
              type={inputOptions.type}
              min={inputOptions.min}
              max={inputOptions.max}
              step={inputOptions.step}
            />
          </div>
        );
      },
    },
  ],
  outputs: [
    {
      id: "number",
      name: "",
      type: "Number",
      compute: (inputs, { number = 0 }) => {
        return number;
      },
    },
  ],
});
